import { NavLink, Outlet } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { I18nProvider } from '../lib/i18n';

const NAV_LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/check-in', label: 'Check In' },
  { to: '/about', label: 'About' },
  { to: '/location', label: 'Location' },
  { to: '/book', label: 'Book Appointment' },
];

export function PublicLayout() {
  return (
    <I18nProvider storageKey="n80_lang_customer" defaultLang="en">
      <div className="flex min-h-screen flex-col">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-2 focus:rounded focus:bg-primary focus:px-4 focus:py-2 focus:text-black"
        >
          Skip to content
        </a>
        <header className="border-b border-border bg-bg/95 backdrop-blur sticky top-0 z-40">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
            <NavLink
              to="/"
              className="flex items-center gap-3"
              aria-label="Nine80 Hair Studio home"
            >
              <Logo className="h-12 w-auto sm:h-14" />
            </NavLink>
            <nav
              aria-label="Primary"
              className="hidden md:flex items-center gap-6 text-sm font-medium"
            >
              {NAV_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    isActive ? 'text-primary' : 'text-fg-muted hover:text-fg transition-colors'
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
            <a
              href="/check-in"
              className="btn-primary hidden sm:inline-flex text-sm px-4 min-h-[40px]"
            >
              Join Walk-In List
            </a>
          </div>
          <nav
            aria-label="Primary mobile"
            className="flex md:hidden overflow-x-auto gap-4 px-4 pb-3 text-sm font-medium"
          >
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  isActive ? 'text-primary whitespace-nowrap' : 'text-fg-muted whitespace-nowrap'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </header>

        <main id="main-content" className="flex-1">
          <Outlet />
        </main>

        <footer className="border-t border-border mt-16">
          <div className="mx-auto max-w-6xl px-4 py-10 grid gap-8 sm:grid-cols-3 text-sm">
            <div>
              <Logo className="h-14 w-auto mb-3" />
              <p className="text-fg-muted">
                50 Concord Commons Pl SW
                <br />
                Concord, NC 28027
              </p>
            </div>
            <div>
              <h2 className="text-fg font-semibold mb-2">Contact</h2>
              <p>
                <a href="tel:+19802558167" className="text-primary hover:underline">
                  (980) 255-8167
                </a>
              </p>
              <p>
                <a href="mailto:Nine80hair@gmail.com" className="text-primary hover:underline">
                  Nine80hair@gmail.com
                </a>
              </p>
              <p>
                <a
                  href="https://www.instagram.com/nine80_hairstudio/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-primary hover:underline"
                >
                  @nine80_hairstudio
                </a>
              </p>
            </div>
            <div>
              <h2 className="text-fg font-semibold mb-2">Hours</h2>
              <p className="text-fg-muted">Mon–Thu: 10am–7pm</p>
              <p className="text-fg-muted">Fri–Sat: 9am–7pm</p>
              <p className="text-fg-muted">Sunday: Closed</p>
            </div>
          </div>
          <div className="border-t border-border py-4 text-center text-xs text-fg-muted">
            © {new Date().getFullYear()} Nine80 Hair Studio
          </div>
        </footer>
      </div>
    </I18nProvider>
  );
}
